import React from 'react';
import { connect } from 'react-redux';
import 'antd/dist/antd.css';
import { Card, Row, Col, Typography } from 'antd';
import PropTypes from 'prop-types';
import ShowPdf from '../pdf/ShowPdf';

const { Title } = Typography;

const ShowDomainCert = ({ domainCert }) => {
  return (
    <Card>
      <Row className="justify-content-center">
        <Col span={24}>
          <Title level={3}>Certificado de dominio de propiedad</Title>
        </Col>
      </Row>
      <Row>
        <ShowPdf pdf={domainCert} />
      </Row>
    </Card >
  );
};

ShowDomainCert.propTypes = {
  domainCert: PropTypes.string.isRequired,
};

const data = (state) => ({
  domainCert: state.contract.domainCert,
});

export default connect(data, null)(ShowDomainCert);